export default __webpack_public_path__ + "static/media/solidarity_disabled.aa6becab.svg";